import { ThemeColor } from 'styles/theme'

export const iconSizes = {
  xLarge: 64,
  large: 48,
  medium: 40,
  small: 24,
  xSmall: 16,
}

export type IconSizes = keyof typeof iconSizes

export type IconProps = {
  /**
   * A key of `ThemeColor`.
   */
  readonly color?: ThemeColor
  /**
   * Class for custom styling
   */
  readonly className?: string
  /**
   * Filename of the svg, eg "glyph-left-arrow"
   */
  readonly icon: string
  /**
   * Viewbox of the svg.
   */
  readonly viewBox: string
  /**
   * Width of the svg.
   */
  readonly width: number
  /**
   * height of the svg.
   */
  readonly height: number
}

export type GeneratedIconProps = {
  color?: ThemeColor
  size?: IconSizes
}
